import CategoryLink from './CategoryLink'
import cn from 'classnames'
import React from 'react'
import CSS from './HomeSection.module.scss'
import coverImage from '../images/playbook-cover.png'

const HomeSection = () => {
  return (
    <div className={cn(CSS.root)}>
      <h1 className={CSS.coverImage}>
        <img src={coverImage} alt='Mashup Garage Playbook' />
      </h1>

      <div className={CSS.intro}>
        <strong>This is our playbook</strong> where we write about the secrets
        we use to design, develop, and build scalable web applications and
        delightful experiences.
      </div>

      <h2 className={CSS.heading}>Explore our process</h2>

      <CategoryLink.List>
        <CategoryLink
          to='/agile.html'
          title='Agile development'
          description='We build products with a resilient agile process'
        />
        <CategoryLink
          to='/design_process.html'
          title='Design process'
          description='Dive into how we design things'
        />
        <CategoryLink
          to='/tech.html'
          title='Our tech stack'
          description='Ruby, Elixir, JavaScript and more'
        />
      </CategoryLink.List>

      <h2 className={CSS.heading}>Learn our tech</h2>

      <CategoryLink.List>
        <CategoryLink
          to='/elixir.html'
          title='Elixir'
          description='Fast, amazing, and scalable'
        />
        <CategoryLink
          to='/react.html'
          title='React'
          description='Building rich user interfaces for the web and mobile'
        />
        <CategoryLink
          to='/rails.html'
          title='Ruby on Rails'
          description="Tech that's optimized for developer happiness"
        />
      </CategoryLink.List>
    </div>
  )
}

export default HomeSection
